import { Facebook, Instagram, Linkedin } from "lucide-react";
import { NAV_LINKS, IMAGES } from "@/data/content";

export default function Footer() {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer className="bg-forest text-cream pt-20 pb-10 px-6 md:px-10" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12 pb-14 border-b border-cream/10">
          <div>
            <img src={IMAGES.logoLight} alt="Proxilia" className="h-9 w-auto object-contain" />
            <p className="mt-4 font-cormorant text-xl text-cream/70">Accompagnement & loisirs senior</p>
            <div className="flex gap-3 mt-6">
              {[Facebook, Instagram, Linkedin].map((Icon, i) => (
                <a key={i} href="#" className="w-10 h-10 rounded-full border border-cream/15 flex items-center justify-center hover:bg-gold hover:border-gold transition-colors" data-testid={`social-${i}`}>
                  <Icon className="w-4 h-4" strokeWidth={1.5} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-gold mb-5">Navigation</div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <button onClick={() => go(l.href)} className="text-cream/70 hover:text-cream transition-colors text-sm">{l.label}</button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-gold mb-5">Informations</div>
            <ul className="space-y-3 text-sm text-cream/70">
              <li><a href="#" className="hover:text-cream transition-colors">Mentions légales</a></li>
              <li><a href="#" className="hover:text-cream transition-colors">Politique de confidentialité</a></li>
              <li><a href="/admin/login" className="hover:text-cream transition-colors" data-testid="footer-admin-link">Espace administrateur</a></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-cream/50">
          <span>© {new Date().getFullYear()} Proxilia · SIRET 106 620 115 00019 · Tous droits réservés.</span>
          <span>Vivre chez soi en toute sérénité.</span>
        </div>
      </div>
    </footer>
  );
}
